import styled from "styled-components";
import Colors from "../../../../themes/Colors";

// Scroll container for the infinite-scroll table: keeps the header sticky and
// highlights rows already in the cart (Figma: light geek-blue).
const TableResultsMapHolder = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  .ant-table-thead > tr > th {
    position: sticky;
    top: 0;
    z-index: 2;
  }
  .ant-table-tbody > tr.in-cart > td {
    background: ${Colors.extraLightPrimary};
  }
  /* Empty state fills the container height and centers the <Result />. */
  .ant-table-placeholder {
    border: none;
  }
  .tableRowBundleButton {
    background-color: ${Colors.snow};
    border-color: ${Colors.primaryAccent};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .tableRowBundleIcon svg {
    width: 16px;
    height: 16px;
  }
  /* Add/remove state overlay on the bundle button (mirrors the screen cards). */
  .tableRowBundleButton .ant-badge-count {
    background: transparent;
    box-shadow: none;
  }
  .tableRowBundleButton .addIconBundle {
    color: ${Colors.primaryAccent};
    font-size: 12px;
    bottom: 12px;
    left: 10px;
  }
  .tableRowBundleButton .minusIconBundle {
    color: #d16060c7;
    font-size: 12px;
    bottom: 0px;
    left: 13px;
  }
`;

export default TableResultsMapHolder;
